/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Max_Duration_SecondsInputs */

const en_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Duration (seconds)`)
};

const fr_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée max (secondes)`)
};

const de_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Dauer (Sekunden)`)
};

const it_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata massima (secondi)`)
};

const ru_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная продолжительность (в секундах)`)
};

const es_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración máxima (segundos)`)
};

const zh_cn2_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大持续时间（秒）`)
};

const ja_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大継続時間（秒）`)
};

const hi_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिकतम अवधि (सेकंड में)`)
};

const pt_pt2_max_duration_seconds = /** @type {(inputs: Max_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração máxima (segundos)`)
};

/**
* | output |
* | --- |
* | "Max Duration (seconds)" |
*
* @param {Max_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const max_duration_seconds = /** @type {((inputs?: Max_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Max_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_max_duration_seconds(inputs)
	if (locale === "de") return de_max_duration_seconds(inputs)
	if (locale === "it") return it_max_duration_seconds(inputs)
	if (locale === "ru") return ru_max_duration_seconds(inputs)
	if (locale === "es") return es_max_duration_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_max_duration_seconds(inputs)
	if (locale === "ja") return ja_max_duration_seconds(inputs)
	if (locale === "hi") return hi_max_duration_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_max_duration_seconds(inputs)
	return en_max_duration_seconds(inputs)
});